import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const buildVersion = process.env.REACT_APP_BUILD_VERSION || 'dev';

  return (
    <footer className="bg-emerald-800 text-white py-4 text-center">
      <p>&copy; {currentYear} Frend AI. All rights reserved.</p>
      <p className="text-xs text-emerald-100 mt-1">Build {buildVersion}</p>
    </footer>
  );
}

export default Footer;
